import { render, staticRenderFns } from "./LockerManagersDropdown.vue?vue&type=template&id=22675084&"
import script from "./LockerManagersDropdown.vue?vue&type=script&lang=js&"
export * from "./LockerManagersDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports